export function getCurrentCulture(): string {
  return document.getElementById('lang')?.getAttribute('lang') || '';
}
export function getCurrentWebsiteKey(): string {
  return document.getElementById('lang')?.getAttribute('data-website-key') || '';
}
